export default __webpack_public_path__ + "check-indeterminate-small.c33763e3097aacac.svg";